import React from 'react';
import { TemplateDialogShell } from './TemplateDialogShell';
import { TemplateForm } from './TemplateForm';

interface TemplateNameAndDescriptionDialogProps {
  templateName: string;
  description: string;
  onTemplateNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  onClose: () => void;
  isLoading: boolean;
  title: string;
  submitLabel: string;
  submittingLabel: string;
  cancelLabel: string;
}

export const TemplateNameAndDescriptionDialog: React.FC<
  TemplateNameAndDescriptionDialogProps
> = props => (
  <TemplateDialogShell onClose={props.onClose}>
    <TemplateForm {...props} />
  </TemplateDialogShell>
);
